import * as React from 'react';
import CountUp from 'react-countup';
import { OverlayTrigger, Glyphicon, Tooltip, ProgressBar } from 'react-bootstrap';
import AppUtils from 'src/utils/AppUtils';
import AppConfig from 'src/config/AppConfig';
import { Icon } from 'react-icons-kit';
import {shield} from 'react-icons-kit/entypo/shield';
import { autorun } from 'mobx';

export default class ScoreContainer extends React.Component<any, any> {

    private scoreHTMLElementRef: React.RefObject<any>;

    constructor(props:any) {
        super(props);

        this.scoreHTMLElementRef = React.createRef();

        this.state = {
            startCount: 0,
        }
    }

    private getScoreChange():string {
        // console.log("Stat: ", this.props.userData.stat)
        let scoreChange:number = this.props.userData.stat - this.state.startCount;
        let scoreString:string = scoreChange.toString();
        if (scoreChange > 0) {
            scoreString = "+" + scoreString;
        }
        return scoreString;
    }

    private getScoreChangeClassName():string {
        let scoreChange:number = this.props.userData.stat - this.state.startCount;
        if (this.props.userData.stat != this.state.startCount) {
            if (scoreChange > 0) {
                return "scoreShow scoreGreen";
            }
            return "scoreShow scoreRed";
        }
        return "scoreHide";
    }

    private getScoreChangeElementOffset():string {
        let w:number = 0
        if (this.props.userData.stat != this.state.startCount && this.scoreHTMLElementRef.current != null) {
            w = this.scoreHTMLElementRef.current.offsetWidth - 12;
        }
        return w.toString();
    }

    private getStatText():string {
        let statText:string = "";
        if (this.props.settings != null && this.props.settings.stat != null) {
            statText = this.props.settings.stat;
        }
        return statText;
    }

    private getIcon():any {
        let icon:any;
        switch (this.props.settings.stat) {
            case AppConfig.SETTINGS_STAT_NAMES.Money:
                icon = <Glyphicon glyph={"piggy-bank"} />
                break;
            case AppConfig.SETTINGS_STAT_NAMES.Economy:
                icon = <Glyphicon glyph={"piggy-bank"} />
                break;
            case AppConfig.SETTINGS_STAT_NAMES.Oil:
                icon = <Glyphicon glyph={"oil"} />
                break;
            case AppConfig.SETTINGS_STAT_NAMES.Health:
                icon = <Glyphicon glyph={"heart"} />
                break;
            case AppConfig.SETTINGS_STAT_NAMES.Barrels:
                icon = <Glyphicon glyph={"oil"} />
                break;
            case AppConfig.SETTINGS_STAT_NAMES.Weight:
                icon = <Glyphicon glyph={"scale"} />
                break;
            case AppConfig.SETTINGS_STAT_NAMES.Efficiency:
                icon = <Glyphicon glyph={"dashboard"} />
                break;
            case AppConfig.SETTINGS_STAT_NAMES.Fire:
                icon = <Glyphicon glyph={"fire"} />
                break;
            case AppConfig.SETTINGS_STAT_NAMES.People:
                icon = <Glyphicon glyph={"user"} />
                break;
            case AppConfig.SETTINGS_STAT_NAMES.Speed:
                icon = <Glyphicon glyph={"flash"} />
                break;
            case AppConfig.SETTINGS_STAT_NAMES.Security:
                // icon = <Glyphicon glyph={"flash"} />
                icon = <Icon id="shieldIcon" className='glyphicon' size={32} icon={shield}/>
                break;
            default:
                icon = <Glyphicon glyph={"warning-sign"} />
                break;
        }
        return icon;
    }

    private getCurrentChapterName(chapterNum:number) {
        return this.props.chapters[chapterNum].name;
    }

    private getProgressBarStyle():any {
        let w:number = Math.floor(100 / this.props.chapters.length);
        let wString:String = w.toString() + "%"
        let style = {width: wString}
        return style
        // let w:number = this.props.chapters.count
    }

    private getScoreContainerStyle():any {
        let scoreStyle = {left: '65px'}
    }

    render() {
        return (
            <div id='scoreContainer' style={{marginLeft: AppUtils.isMobile == false && this.props.userData.admin == true ? '85px' : '', width: AppUtils.isMobile ? "fit-content" : "auto"}}>
                {
                this.props.loaded != false ? 
                <div>
                    
                        <div className='stat' id='param'>
                            <div className="scoreContainer" ref={this.scoreHTMLElementRef}>
                                {this.getIcon()}
                                <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} placement="bottom" overlay={<Tooltip id="tooltip"><strong>{this.getStatText()}</strong></Tooltip>}>
                                <div className="scoreInfo">
                                    <p className="title">{this.getStatText().toUpperCase()}</p>
                                    <p className="score">
                                        <CountUp
                                            start={parseInt(this.state.startCount)}
                                            end={parseInt(this.props.userData.stat)}
                                            duration={2}
                                            prefix={this.props.settings != null ? this.props.settings.prefix : ""}
                                            suffix={this.props.settings != null ? this.props.settings.suffix : ""}
                                            onEnd={() => this.setState({startCount: this.props.userData.stat})}
                                            >
                                        </CountUp>
                                    </p>
                                </div>
                                </OverlayTrigger>
                                <div id="chapterProgress">
                                    <p className="title">{"PROGRESS"}</p>
                                    <div>
                                        {this.props.chapters.map((c:any, i:number) => 
                                            <OverlayTrigger key={"progressbar" + i.toString()} delay={AppConfig.TOOLTIP_DELAY} placement="bottom" overlay={<Tooltip id="tooltip"><strong>{this.getCurrentChapterName(i)}</strong></Tooltip>}>
                                                <ProgressBar striped bsStyle="info" now={this.props.currentChapter > i ? 100 : 0} style={this.getProgressBarStyle()} />
                                            </OverlayTrigger>
                                        )}
                                    {/* <ProgressBar striped bsStyle="info" now={this.props.currentChapter >= 1 ? 100 : 0} style={{width:"50%"}} />
                                    <ProgressBar striped bsStyle="info" now={60} style={{width:"50%"}} /> */}
                                    </div>
                                </div>
                                
                            </div>
                            <p style={{paddingLeft: this.getScoreChangeElementOffset() + "px"}} className={this.getScoreChangeClassName()}>
                                {this.getScoreChange()}
                            </p>
                        </div>
                    

                    {/* <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip"><strong>Score</strong></Tooltip>}>
                        <div className='stat' id='score'><Glyphicon glyph="flash" /><p>{this.props.userData.score}</p></div>
                    </OverlayTrigger> */}
                </div> : null
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ScoreContainer.tsx